export const cabinClassOptions = [
	{
		id: 'INTERIOR',
		label: 'Interior',
	},
	{
		id: 'OUTSIDE',
		label: 'Outside View',
	},
	{
		id: 'BALCONY',
		label: 'Balcony',
	},
	{
		id: 'DELUXE',
		label: 'Suite',
	},
];

export const HEADER_GDP_APP_NAME = 'GDP-APP';

export const IMAGE_AEM_CLOUD_PREFIX = '/is/image';

export const PATH_PROMOTION_TERMS_AND_CONDITIONS = 'terms-and-conditions/promotions';

export const SERVER_TOGGLES = {
	SHOW_ALERTS_ON_HEADER: 'show-alerts-on-header',
	SHOW_MY_OFFERS: 'show-my-offers',
	ENABLE_TARGETED_OFFERS_FEATURE: 'enable-targeted-offers-feature',
	SHOW_IN_ORDER_THE_PILLS_OF_THE_FILTERS: 'show-in-order-the-pills-of-the-filters',
	SHOW_TARGETED_OFFERS_PERKS_QUALIFIERS: 'show-targeted-offers-perks-qualifiers',
	ENABLE_MEDALLIA_EMBEDDED_SURVEY: 'enable-medallia-embedded-survey',
	ENABLE_SENDING_LOYALTYID_IN_CRUISE_SEARCH_QUERY: 'enable-sending-loyaltyid-in-cruise-search-query',
	SHOW_PROMOTION_BANNER: 'show-promotion-banner',
	ENABLE_AEM_UNIVERSAL_NAVIGATION: 'enable-aem-universal-navigation',
	ENABLE_PAGE_INDEXING: 'enable-page-indexing',
	GRAPH_BLUE_GREEN_COLOR: 'graph-blue-green-color',
	ENABLE_RECOMMENDED_SORT_OPTION: 'enable-recommended-sort-option',
	ENABLE_DEFAULT_SORT_OPTION: 'enable-default-sort-option',
	SHOW_UNIQUE_DESTINATIONS: 'show-unique-destinations',
	SHOW_NUMBER_OF_GUESTS: 'show-number-of-guests',
	ENABLE_CRUISE_DETAILS_PANEL_VARIANT: 'enable-cruise-details-panel-variant',
	MOVE_TEALIUM_SCRIPT_INSIDE_HEAD: 'move-tealium-script-inside-head',
	MOVE_ONETRUST_SCRIPT_INSIDE_HEAD: 'move-onetrust-script-inside-head',
	BYPASS_APOLLO_GATEWAY_FOR_CS_CALLS: 'bypass-apollo-gateway-for-cs-calls',
	ENABLE_RIVER_CRUISES: 'enable-river-cruises',
	ENABLE_DEFAULT_VOYAGE_TYPE: 'enable-default-voyage-type',
};
export const SERVER_COMMON_TOGGLES = {
	ENABLE_AVIOS: 'enable-avios',
	ENABLE_NEW_RECOMMENDSTIONS_ENGINE: 'enable-new-recommendations-engine',
};

export const SERVER_USER_ID = 'RWD_CRUISE_SEARCH_SERVER';

export const SEARCH_CARD = 'search_card';

export const DETAIL_MODAL = 'detail_modal';

export const CRUISE_SEARCH_APP_ID = 'cs';
